import { configureStore } from '@reduxjs/toolkit';
import mapReducer from '../redux/mapSlice';
import municipalityReducer from '../redux/municipialitySlice';
import infoMessageReducer from '../redux/infoMessageSlice';
import editReducer from '../redux/editSlice';

export const store = configureStore({
  reducer: {
    map: mapReducer,
    municipality: municipalityReducer,
    infoMessage: infoMessageReducer,
    edit: editReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
